import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _86193b50 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _1ef4fe60 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _1740eaf3 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _1a4834cb = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _39a5716b = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _c7f63eaa = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _73302829 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _abea8a78 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _0feb5166 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _cb999324 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _c4ff4e7c = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _16c3260e = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _6ba320eb = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1f122f23 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _46eb574e = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _df3bfa96 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _380f59ab = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _3c344550 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _3d7794b0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _1813c555 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _4f5eaae7 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _8e9e3b4a = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _79dc3f32 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _a8b1f910 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _4da6f2ad = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _775fef33 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _ff1f0e5e = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _ba151792 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _3c0e6a6e = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _54c2a842 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _43641b8a = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _34b25342 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _7d45e0f8 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _2c0bfde0 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _1a7c167b = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _aa2993ba = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _4623d58a = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _16e39d56 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _059997d5 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _d46eaebe = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _f42c1004 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _7dfa38ef = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _4459cb9c = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0c491e3e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _155185e8 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _c678e5fc = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _583e8e8a = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _16b8e8ac = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _7e0a19b1 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _237842f9 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _a5e18d74 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _683e4238 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7af0196b = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _0a0bddd0 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _c5e6685a = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _4b2b7dac = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _3adc0339 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _350812b8 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _dfba32f0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _e713bb4a = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _13777872 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _7be03e2a = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _3d837ba3 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _7e261ac0 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _53e30e1b = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _6f24fc72 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _7826d293 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _44efc8f5 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _f91cb8ac = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _5bb1dff8 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _19fc5758 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _e0a82a74 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _8fee191c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _7d415814 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _86193b50,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _1ef4fe60,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _1740eaf3,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _1a4834cb,
    name: "calendar"
  }, {
    path: "/customer",
    component: _39a5716b,
    name: "customer"
  }, {
    path: "/details",
    component: _c7f63eaa,
    name: "details"
  }, {
    path: "/goals",
    component: _73302829,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _abea8a78,
    name: "maisoku"
  }, {
    path: "/media",
    component: _0feb5166,
    name: "media"
  }, {
    path: "/privacy",
    component: _cb999324,
    name: "privacy"
  }, {
    path: "/project",
    component: _c4ff4e7c,
    name: "project"
  }, {
    path: "/response",
    component: _16c3260e,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _6ba320eb,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1f122f23,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _46eb574e,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _df3bfa96,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _380f59ab,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _3c344550,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _3d7794b0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _1813c555,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _4f5eaae7,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _8e9e3b4a,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _79dc3f32,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _a8b1f910,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _4da6f2ad,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _775fef33,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _ff1f0e5e,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _ba151792,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _3c0e6a6e,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _54c2a842,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _43641b8a,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _34b25342,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _7d45e0f8,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _2c0bfde0,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _1a7c167b,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _aa2993ba,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _4623d58a,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _16e39d56,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _059997d5,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _d46eaebe,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _f42c1004,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _7dfa38ef,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _4459cb9c,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0c491e3e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _155185e8,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _c678e5fc,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _583e8e8a,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _16b8e8ac,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _7e0a19b1,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _237842f9,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _a5e18d74,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _683e4238,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _7af0196b,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _0a0bddd0,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _c5e6685a,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _4b2b7dac,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _3adc0339,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _350812b8,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _dfba32f0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _e713bb4a,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _13777872,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _7be03e2a,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _3d837ba3,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _7e261ac0,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _53e30e1b,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _6f24fc72,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _7826d293,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _44efc8f5,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _f91cb8ac,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _5bb1dff8,
    name: "property-property",
    children: [{
      path: "contact",
      component: _19fc5758,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _e0a82a74,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _8fee191c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _7d415814,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
